(function(){
  // Guard: skip all Trendsi suppression logic on the Policies page to avoid accidental hiding.
  try{
    var lp = window.location.pathname || '';
    if(/\/pages\/polic/i.test(lp)){ return; }
  }catch(e){}
  function hasTrendsiText(t){
    if (!t) return false;
    t = String(t).toLowerCase();
    return t.indexOf('trendsi') >= 0;
  }
  function isByTrendsi(t){
    if (!t) return false;
    t = String(t).trim().toLowerCase().replace(/\s+/g,' ');
    return /\bby\s+trendsi\b/.test(t);
  }
  function hideNode(el){
    if (!el) return;
    el.style.display = 'none';
    el.setAttribute('data-trendsi-hidden','1');
  }
  function forEachMatch(root, selector, callback){
    if (!root || root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.nodeType === 1 && root.matches && root.matches(selector)) {
      callback(root);
    }
    root.querySelectorAll(selector).forEach(callback);
  }
  function hideTrendsiOnce(root){
    root = root || document;

    // 1) Hero sublines like <p class="sub">Trendsi</p> or "by Trendsi"
    forEachMatch(root, '.hitch-product-hero .sub, .hitch-col-hero__copy .sub, .product .sub, p.sub', function(el){
      var txt = (el.textContent || '').trim();
      if (isByTrendsi(txt) || txt.trim().toLowerCase() === 'trendsi') {
        hideNode(el);
      }
    });

    // 2) Any vendor containers (commonly used classes/attrs)
    var vendorSel = [
      '.product-vendor',
      '.product__vendor',
      '.vendor',
      '[data-product-vendor]',
      '.product-meta__vendor',
      '.product__text-vendor'
    ].join(',');
    forEachMatch(root, vendorSel, function(el){
      if (el.getAttribute('data-trendsi-hidden') === '1') return;
      var full = (el.textContent || '').trim();
      if (hasTrendsiText(full) || isByTrendsi(full)) {
        hideNode(el);
        return;
      }
      // Pattern: "by " + <a>Trendsi</a> (or span)
      var link = el.querySelector('a, span, strong, em');
      if (link && hasTrendsiText(link.textContent || '')) {
        // Also confirm there is a "by" text somewhere nearby
        var raw = full.toLowerCase();
        if (raw.indexOf('by ') >= 0) {
          hideNode(el);
        }
      }
    });

    // 3) Fallback: likely short text elements that literally equal "by Trendsi"
    forEachMatch(root, 'p, span, small', function(el){
      if (el.getAttribute && el.getAttribute('data-trendsi-hidden') === '1') return;
      if (el.childNodes && el.childNodes.length === 1 && el.childNodes[0].nodeType === 3) {
        var t = (el.textContent || '').trim();
        if (isByTrendsi(t)) {
          hideNode(el);
        }
      }
    });

    // 4) Heart / wishlist style injected badges often from Trendsi: heuristic removal
    //    Only target small interactive elements (buttons / links) and tiny wrappers.
    //    NEVER hide large content containers — product descriptions may contain
    //    the word "favorite" which would false-positive the entire PDP.
    forEachMatch(root, 'button, a', function(el){
      if (el.getAttribute && el.getAttribute('data-trendsi-hidden') === '1') return;
      // Skip anything inside the product form or product content areas
      if (el.closest && (el.closest('.p-form') || el.closest('.p-buy') || el.closest('.rte') || el.closest('.p-acc'))) return;
      var cls = (el.className || '').toLowerCase();
      var aria = (el.getAttribute('aria-label')||'').toLowerCase();
      var lbl = (el.textContent||'').trim().toLowerCase();
      var heur = (
        /wishlist|wish|favorite|favourite|heart/.test(cls) ||
        /wishlist|wish|favorite|favourite/.test(aria) ||
        (lbl.length < 40 && /wishlist|favorite/.test(lbl))
      );
      if(heur){ hideNode(el); }
    });
  }

  function onReady(fn){
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  onReady(function(){
    hideTrendsiOnce(document);
    // Capture dynamic content updates
    var mo = new MutationObserver(function(muts){
      muts.forEach(function(m){
        if (m.addedNodes && m.addedNodes.length){
          m.addedNodes.forEach(function(n){
            if (n.nodeType === 1){ hideTrendsiOnce(n); }
          });
        }
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  });
})();
